import React from 'react';
import { ICallTranscriptionItem } from './CallInfo';
import { Slider } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import { CallTranscriptionInfoTooltip } from '../modals/CallTranscriptionModal';
import {
  FEATURE_NOT_SUPPORTED_STYLE,
  getFeatureNotSupportedLabel,
  getLanguageCode,
  isEnglishLanguageCode,
} from './CallTranscriptionSummary';

const CustomSlider = withStyles({
  track: {
    width: '100% !important',
    height: '8px',
    borderRadius: '20px',
    border: '.5px solid #ffffff',
    background: 'linear-gradient(to right, #ff0000,  #FFFF00 50%, #00FF00);',
  },
  thumb: {
    width: '30px',
    height: '30px',
    boxShadow: '0px 0px 3px #a7a7a7, 0px 0px 1px #a7a7a7',
    borderRadius: '40px',
    border: '1px solid #ffffff',
    background: '#eee',
    marginTop: '-10px',
    cursor: 'default',
    fontSize: '1rem',
  },
  mark: {
    width: 1.5,
    height: 8,
    borderRadius: 0,
    color: '#fff',
  },
  rail: {
    display: 'none',
  },
})(Slider);

const marks = [
  {
    value: 0,
    label: 'Low',
  },
  {
    value: 25,
    label: '',
  },
  {
    value: 50,
    label: '',
  },
  {
    value: 75,
    label: '',
  },
  {
    value: 100,
    label: 'High',
  },
];

export const CallStrength = (props: {
  item: ICallTranscriptionItem;
  isLoading: boolean;
}) => {
  if (props.isLoading) return null;

  const callStrength = props?.item?.callStrength;

  const languageCode = getLanguageCode(props?.item);
  const hasSentimentAnalysisFeature = isEnglishLanguageCode(languageCode);

  const TextThumbComponent = (props) => {
    return (
      <span {...props}>
        <span
          style={{
            fontSize: '0.9rem',
            fontWeight: 500,
            color: 'black',
            cursor: 'default',
          }}
        >
          {callStrength}
        </span>
      </span>
    );
  };

  return (
    <div style={{ margin: '0 8px' }}>
      {hasSentimentAnalysisFeature ? (
        typeof callStrength === 'number' ? (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                gap: '4px',
                fontSize: '13px',
              }}
            >
              <Typography
                style={{ textAlign: 'center', fontWeight: 600 }}
                id="input-slider"
                gutterBottom
              >
                Conversation Strength
              </Typography>

              <CallTranscriptionInfoTooltip
                title={
                  'The overall strength of this call based on factors like length, sentiment, usage of phrases and keywords, and more. Both high and low strength calls are great training tools to provide examples of exemplary calls to replicate as well as weaker calls to avoid repeating.'
                }
              />
            </div>
            <CustomSlider
              style={{ width: '100%', pointerEvents: 'none' }}
              ThumbComponent={TextThumbComponent}
              id="slide"
              step={0.25}
              aria-label="Conversation Strength"
              value={callStrength}
              marks={marks}
              min={0}
              max={100}
            />
          </>
        ) : (
          <span>
            You have not selected any options for calculating the call strength.
          </span>
        )
      ) : (
        <div style={{ ...FEATURE_NOT_SUPPORTED_STYLE, minHeight: 112 }}>
          {getFeatureNotSupportedLabel(languageCode)}
        </div>
      )}
    </div>
  );
};
